import { Component, IterableDiffers, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AzmoonMaharatAnswer_Interface, Empty_AzmoonMaharatAnswer_Interface } from 'src/app/Interface/AzmoonMaharatAnswer_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { AzmoonMaharatService } from 'src/app/Service/AzmoonMaharat/AzmoonMaharat.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-AzmoonMaharatMainConfirm',
  templateUrl: './AzmoonMaharatMainConfirm.component.html',
  styleUrls: ['./AzmoonMaharatMainConfirm.component.scss']
})
export class AzmoonMaharatMainConfirmComponent implements OnInit {

  Token: String = ""
  Filter_title: string = ""
  Filter_dsc: string = ""
  page: number = 0;
  Procssing: boolean = false
  BaseUrl = environment.BaseUrl+"File/AzmoonMaharat/"

  modalRef_Delete: any;
  modalRef_File: any;

  constructor(
    private AzmoonMaharat_Service: AzmoonMaharatService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private modalService: BsModalService
  ) { }


  DataList_AzmoonMaharat: Array<AzmoonMaharatAnswer_Interface> = []
  Data_Seleted_Delete: AzmoonMaharatAnswer_Interface = Empty_AzmoonMaharatAnswer_Interface()

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token, 2220).subscribe(
      data => {
        this.ReadData_AzmoonMaharat()
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )

  }

  ReadData_AzmoonMaharat() {
    this.Procssing = true
    this.AzmoonMaharat_Service.GetSignInCustomerConfirm(this.Token).subscribe(
      data => {
        this.DataList_AzmoonMaharat = data
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  Change_Filter_title() {
    this.page = 0
  }


  SubmitSignInCustomerConfirm(status:number) {
    this.Procssing = true
    this.modalRef_File.hide()
    this.AzmoonMaharat_Service.SubmitSignInCustomerConfirm(this.Data_Seleted_Delete.id,
      status,
      this.Filter_dsc,
      this.Token).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("The information was registered successfully")
        this.ReadData_AzmoonMaharat()
        this.Procssing = false
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }

  openModalFile(template: TemplateRef<any>, Record:AzmoonMaharatAnswer_Interface) {
    this.Data_Seleted_Delete = Record
    this.modalRef_File = this.modalService.show(template);
  }

}
